export enum HaltReason {
    USER_NOT_RESPONDING = 'USER_NOT_RESPONDING',
    NO_INTERNET_CONNECTION = 'NO_INTERNET_CONNECTION',
    INVALID_MEETING_ROOM_NUMBER = 'INVALID_MEETING_ROOM_NUMBER',
    INVALID_SDP_FORMAT = 'INVALID_SDP_FORMAT',
    ACCESS_FORBIDDEN = 'ACCESS_FORBIDDEN',
    MEETING_ROOMS_QUOTA_EXCEEDED = 'MEETING_ROOMS_QUOTA_EXCEEDED',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
